export enum FarmResetType {
    None,
    Daily,
    BiWeekly,
    Weekly,
    Never,
    Monthly,
}
